import { CloseOutlined, EditOutlined } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';
import { useContext } from 'react';

import { VenueDatesContext } from '@/ui/pages/app/project/venue/dates/components/VenueDatesContext.ts';
import { ColorsRaw } from '@/ui/theme/colors-raw';

const getAnsweredBoxStyle = ({
  editing,
  panelOpen,
}: {
  editing: boolean;
  panelOpen: boolean;
}) => {
  if (panelOpen) {
    return {
      border: editing
        ? `1px solid ${ColorsRaw.anthracite.Anthracite_5}`
        : `1px solid ${ColorsRaw.anthracite.Anthracite_3}`,
      borderRadius: '12px',
      p: 2,
      mt: 2,
      backgroundColor: editing ? '' : ColorsRaw.anthracite.Anthracite_2,
    };
  }

  return {
    border: `1px solid ${ColorsRaw.anthracite.Anthracite_3}`,
    borderRadius: '12px',
    p: 2,
    mt: 2,
  };
};

interface QEProps {
  removeFromEditing: () => void;
  form: React.ReactNode;
  title: string;
  subTitle?: string;
}

export function QuizEdition({
  removeFromEditing,
  form,
  title,
  subTitle,
}: QEProps) {
  const { panelOpen } = useContext(VenueDatesContext);

  return (
    <Box sx={getAnsweredBoxStyle({ editing: true, panelOpen })}>
      <Box display={'flex'} justifyContent={'space-between'} alignItems={'top'}>
        <div>
          <Typography sx={{ fontWeight: 'bold', fontSize: 20, mb: 1 }}>
            {title}
          </Typography>
          <Typography sx={{ fontWeight: 'medium', fontSize: 16, mb: 1 }}>
            {subTitle}
          </Typography>
        </div>
        <Button
          sx={{
            p: 1,
            ml: 1,
            minWidth: 0,
            borderRadius: '50%',
            width: 'fit-content',
            height: 'fit-content',
          }}
          onClick={() => removeFromEditing()}
        >
          <CloseOutlined sx={{ fontSize: 18 }} />
        </Button>
      </Box>
      {form}
    </Box>
  );
}

interface QNEProps {
  addToEditing: () => void;
  answeredValues: string[];
  title: string;
  isAnswered: boolean;
}

export function QuizNotEdition({
  addToEditing,
  answeredValues,
  title,
  isAnswered,
}: QNEProps) {
  const { panelOpen } = useContext(VenueDatesContext);

  return (
    <Box sx={getAnsweredBoxStyle({ editing: false, panelOpen })}>
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Typography sx={{ color: ColorsRaw.main.Navy_Light, fontSize: 16 }}>
          {title}
        </Typography>

        {/* {panelOpen ? ( */}
        <Button
          sx={{
            p: 1,
            minWidth: 0,
            borderRadius: '50%',
            width: 'fit-content',
            height: 'fit-content',
          }}
          onClick={() => addToEditing()}
        >
          <EditOutlined sx={{ fontSize: 18 }} />
        </Button>
        {/* ) : (
          <>
            {isAnswered ? (
              <CheckCircle color="primary" sx={{ fontSize: 18 }} />
            ) : (
              <EditOutlined color="primary" sx={{ fontSize: 18 }} />
            )}
          </>
        )} */}
      </Box>
      {isAnswered && (
        <Box marginTop={1}>
          {answeredValues.map((value, i) => (
            <Typography
              key={'anwseredValue' + i}
              sx={{ fontSize: 20, fontWeight: 'bold' }}
            >
              {value}
            </Typography>
          ))}
        </Box>
      )}
    </Box>
  );
}

interface NQEProps {
  form: React.ReactNode;
  title: string;
  subTitle?: string;
  id: string;
}

export function NewQuizEdition({ form, title, id, subTitle }: NQEProps) {
  const { panelOpen } = useContext(VenueDatesContext);

  return (
    <Box
      id={id}
      sx={{
        border: panelOpen
          ? `1px solid ${ColorsRaw.anthracite.Anthracite_5}`
          : `1px solid ${ColorsRaw.anthracite.Anthracite_3}`,
        borderRadius: '12px',
        p: 2,
        mt: 2,
        backgroundColor: panelOpen ? '' : ColorsRaw.anthracite.Anthracite_2,
      }}
    >
      <Box
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Typography
          sx={{
            fontWeight: panelOpen ? 'bold' : '',
            fontSize: panelOpen ? 20 : 16,
            mb: panelOpen ? 1 : 0,
            color: panelOpen ? '' : ColorsRaw.main.Navy_Light,
          }}
        >
          {title}
        </Typography>

        {!panelOpen && (
          <EditOutlined
            color="primary"
            sx={{
              fontSize: 18,
            }}
          />
        )}
      </Box>
      {panelOpen && (
        <Typography
          sx={{
            fontWeight: 'medium',
            fontSize: 16,
            mb: 1,
            color: ColorsRaw.secondary.Light_Grey,
          }}
        >
          {subTitle}
        </Typography>
      )}
      {panelOpen && form}
    </Box>
  );
}
